import { Component, OnInit } from '@angular/core';
import { Tender } from "../../models/inModels/Tender";
import { SelectItem, LazyLoadEvent, Message, ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { TenderService } from "../../services/business/tender.service";
import { DataTable } from "primeng/components/datatable/datatable";
import { NotificationContentType } from "../../models/inModels/MessageModel";

@Component({
	selector: 'app-tenders',
	templateUrl: './tenders.component.html',
	styleUrls: ['./tenders.component.css']
})
export class TendersComponent {
	items: Tender[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	contentId: number;
	contentType: NotificationContentType;
	sendAllDialog = false;
	constructor(
		private service: TenderService,
		private router: Router,
		private confirmationService: ConfirmationService) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
	}

	changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	edit(tender: Tender) {
		console.log(tender);
		this.router.navigate(['tenders/edit', tender.Id]);
	}

	sendAllDialogOpen(tender: Tender) {
		this.contentId = tender.Id;
		this.contentType = NotificationContentType.Tender;
		this.sendAllDialog = true;
	}

	delete(tender: Tender) {
		console.log(tender);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete this tender?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.delete(tender.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/tenders/tenders.component.ts